import React from "react";
import Headertop from '../components/Headertop';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function TestSeries (){
    return (
        <>
            <Headertop /> 
            <Navbar />
        
            <Footer />
        </>
    );
}
export default TestSeries;